import {useAppDispatch} from '../../stores/configureStore'
import StyleSheet from '../../utils/helpers/styleSheet'
import {Img} from '../../models/editor/img'
import ImageIcon from '../icons/ImageIcon'
import {handleUpdatedAttributes} from '../../utils/helpers/attributeHelper'
import ControlGroup from './ControlGroup'
import {useTranslation} from 'react-i18next'

interface Props {
  img: Img
}

const styles: StyleSheet = {
  iconWrapper: {
    margin: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    alignItems: 'center',
  },
  activeIcon: {
    filter: 'contrast(0.03)',
  },
}

export default function ImgFilters({img}: Props) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <ControlGroup title={t('Filter')}>
      <>
        <div style={styles.iconWrapper}>
          <ImageIcon
            title={t('Inverz')}
            style={
              img.filters.inverse
                ? {...styles.icon, ...styles.activeIcon}
                : styles.icon
            }
            onClick={() =>
              handleUpdatedAttributes(dispatch, img, {
                filters: {
                  ...img.filters,
                  inverse: !img.filters.inverse,
                },
              })
            }
          />
          <span style={styles.text} className="text">
            {t('Inverz')}
          </span>
        </div>
        <div style={styles.iconWrapper}>
          <ImageIcon
            title={t('Fekete-fehér')}
            style={
              img.filters.monochrome
                ? {...styles.icon, ...styles.activeIcon}
                : styles.icon
            }
            onClick={() =>
              handleUpdatedAttributes(dispatch, img, {
                filters: {
                  ...img.filters,
                  monochrome: !img.filters.monochrome,
                },
              })
            }
          />
          <span style={styles.text} className="text">
            {t('Fekete-fehér')}
          </span>
        </div>
        <div style={styles.iconWrapper}>
          <ImageIcon
            title={t('Szépia')}
            style={
              img.filters.sepia
                ? {...styles.icon, ...styles.activeIcon}
                : styles.icon
            }
            onClick={() =>
              handleUpdatedAttributes(dispatch, img, {
                filters: {
                  ...img.filters,
                  sepia: !img.filters.sepia,
                },
              })
            }
          />
          <span style={styles.text} className="text">
            {t('Szépia')}
          </span>
        </div>
      </>
    </ControlGroup>
  )
}
